// Tool icon mappings
export const TOOL_ICONS = {
  // Scan Process - Preparing Scan
  scan_preparing_scissors: '/tool_icons/scan_preparing_scissors.png',
  scan_preparing_eraser: '/tool_icons/scan_preparing_eraser.png',
  scan_preparing_pencil: '/tool_icons/scan_preparing_pencil.png',
  
  // Scan Process - Axes Alignment
  scan_axes_pin: '/tool_icons/scan_axes_pin.png',
  scan_axes_movement: '/tool_icons/scan_axes_movement.png',
  
  // Main Process - Rectification
  main_rectification_measure_reduction: '/tool_icons/main_rectification_measure_reduction.png',
  main_rectification_scoop_recharge: '/tool_icons/main_rectification_scoop_recharge.png',
  main_rectification_blocking_zone: '/tool_icons/main_rectification_blocking_zone.png',
  main_rectification_global_reduction: '/tool_icons/main_rectification_global_reduction.png',
  main_rectification_smoothning: '/tool_icons/scan_preparing_eraser_smoothning.png',
  
      // Main Process - Elongation
    main_elongation_elongation: '/tool_icons/main_elongation_elongation.png',
  
  // Main Process - Trimline
  main_trimline_trimline: '/tool_icons/main_trimline_trimline.png',
  
  // Main Process - Flares
  main_flares_flare: '/tool_icons/main_flares_flares.png',
  main_flares_smoothning: '/tool_icons/scan_preparing_eraser_smoothning.png',
  
  // Main Process - Thickness
  main_thickness_thickness: '/tool_icons/main_thickness_thickness.png',
  main_thickness_measure: '📐',
  main_thickness_adjust: '⚙️',
  
  // Main Process - Locking Mechanism
  main_locking_lock: '/tool_icons/main_lockmechanism_lock_system.png',
  main_locking_position: '📍',
  main_locking_adjust: '⚙️',
  
  // Main Process - Alignment
  // main_alignment_align: '↔️',
  // main_alignment_rotate: '🔄',
  // main_alignment_measure: '📐',
  
  // Main Process - Valve
  main_valve_valve: '/tool_icons/main_valve_valvue.png',
  main_valve_position: '📍',
  main_valve_adjust: '⚙️',
  
  // Main Process - Pads
  main_pads_pad: '/tool_icons/main_pad_pad.png',
  main_pads_position: '📍',
  main_pads_adjust: '⚙️',
  
  // Main Process - Finalization
  main_finalization_review: '👁️',
  main_finalization_export: '📤',
  main_finalization_save: '💾'
};

  
  // Tool name mappings for readable display names
export const TOOL_NAMES = {
  // Scan Process - Preparing Scan
  scan_preparing_scissors: 'Scissors',
  scan_preparing_eraser: 'Eraser',
  scan_preparing_pencil: 'Pencil',
  
  // Scan Process - Axes Alignment
  scan_axes_pin: 'Axes',
  scan_axes_movement: 'Alignment',
  
  // Main Process - Rectification
  main_rectification_measure_reduction: 'Measure Reduction',
  main_rectification_scoop_recharge: 'Carve Relief',
  main_rectification_blocking_zone: 'Blocking Zone',
  main_rectification_global_reduction: 'Global Reduction',
  main_rectification_smoothning: 'smoothening',
  
  // Main Process - Elongation
  main_elongation_elongation: 'Elongation',
  
  // Main Process - Trimline
  main_trimline_trimline: 'Trimline',
  
  // Main Process - Flares
  main_flares_flare: 'Flare',
  main_flares_smoothning: 'Flares Smoothening',
  
  // Main Process - Thickness
  main_thickness_thickness: 'Thickness',
  main_thickness_measure: 'Measure',
  main_thickness_adjust: 'Adjust',
  
  // Main Process - Locking Mechanism
  main_locking_lock: 'Locking System',
  main_locking_position: 'Position',
  main_locking_adjust: 'Adjust',
  
  // Main Process - Alignment
  main_alignment_align: 'Align',
  main_alignment_rotate: 'Rotate',
  main_alignment_measure: 'Measure',
  
  // Main Process - Valve
  main_valve_valve: 'Valve',
  main_valve_position: 'Position',
  main_valve_adjust: 'Adjust',
  
  // Main Process - Pads
  main_pads_pad: 'Pad',
  main_pads_position: 'Position',
  main_pads_adjust: 'Adjust',
  
  // Main Process - Finalization
  main_finalization_review: 'Review',
  main_finalization_export: 'Export',
  main_finalization_save: 'Save'
};

// tools.js

export const TOOLS_CONFIG = {
    SCAN_PROCESS: {
      PREPARING_SCAN: {
        TRIM: { id: 'scan_preparing_scissors', name: TOOL_NAMES.scan_preparing_scissors, icon: '/tool_icons/scan_preparing_scissors.png' },
        ERASE: { id: 'scan_preparing_eraser', name: TOOL_NAMES.scan_preparing_eraser, icon: '/tool_icons/scan_preparing_eraser.png' },
        FILL: { id: 'scan_preparing_pencil', name: TOOL_NAMES.scan_preparing_pencil, icon: '/tool_icons/scan_preparing_pencil.png' },
      },
      AXES_ALIGNMENT: {
        AXES: { id:'scan_axes_pin', name: TOOL_NAMES.scan_axes_pin, icon: '/tool_icons/scan_axes_pin.png' },
        ALINGMENT: { id:'scan_axes_movement', name: TOOL_NAMES.scan_axes_movement, icon: '/tool_icons/scan_axes_movement.png' },
      },
    },
    MAIN_PROCESS: {
      RECTIFICATION: {
        main_rectification_measure_reduction: { id:'main_rectification_measure_reduction', name: 'Measure Reduction', icon: '/tool_icons/main_rectification_measure_reduction.png' },
        main_rectification_blocking_zone: { id:'main_rectification_blocking_zone', name: 'Blocking Zone', icon: '/tool_icons/main_rectification_blocking_zone.png' },
        main_rectification_global_reduction: { id:'main_rectification_global_reduction', name: 'Global Reduction', icon: '/tool_icons/main_rectification_global_reduction.png' },
        main_rectification_scoop_recharge: { id:'main_rectification_scoop_recharge', name: 'Scoop Recharge', icon: '/tool_icons/main_rectification_scoop_recharge.png' },
        main_rectification_smoothning: { id:'main_rectification_smoothning', name: 'Smoothing', icon: '/tool_icons/scan_preparing_eraser_smoothning.png' },
      },
      ELONGATION: {
        main_elongation_elongation: { id:'main_elongation_elongation', name: 'Elongation', icon: '/tool_icons/main_elongation_elongation.png' },
      },
      TRIMLINE: {
        main_trimline_trimline: { id:'main_trimline_trimline', name: 'Trimline', icon: '/tool_icons/main_trimline_trimline.png' },
      },
      FLARES: {
        main_flares_flare: { id:'main_flares_flare', name: 'Flare', icon: '/tool_icons/main_flares_flares.png' },
        main_flares_smoothning: { id:'main_flares_smoothning', name: 'Flares Smoothening', icon: '/tool_icons/scan_preparing_eraser_smoothning.png' },
      },
      THICKNESS: {
        main_thickness_thickness: { id:'main_thickness_thickness', name: 'Thickness', icon: '/tool_icons/main_thickness_thickness.png' },
        main_thickness_measure: { name: 'Measure', icon: '📐' },
        main_thickness_adjust: { name: 'Adjust', icon: '⚙️' },
      },
      LOCKING_MECHANISM: {
        main_locking_lock: { id:'main_locking_lock', name: 'Locking System', icon: '/tool_icons/main_lockmechanism_lock_system.png' },
        main_locking_position: { name: 'Position', icon: '📍' },
        main_locking_adjust: { name: 'Adjust', icon: '⚙️' },
      },
      ALIGNMENT: {
        main_alignment_align: { name: 'Align', icon: '↔️' },
        main_alignment_rotate: { name: 'Rotate', icon: '🔄' },
        main_alignment_measure: { name: 'Measure', icon: '📐' },
      },
      VALVE: {
        main_valve_valve: { name: 'Valve', icon: '🔧' },
        main_valve_position: { name: 'Position', icon: '📍' },
        main_valve_adjust: { name: 'Adjust', icon: '⚙️' },
      },
      PADS: {
        main_pads_pad: { name: 'Pad', icon: '🛡️' },
        main_pads_position: { name: 'Position', icon: '📍' },
        main_pads_adjust: { name: 'Adjust', icon: '⚙️' },
      },
      FINALIZATION: {
        main_finalization_review: { name: 'Review', icon: '👁️' },
        main_finalization_export: { name: 'Export', icon: '📤' },
        main_finalization_save: { name: 'Save', icon: '💾' },
      },
    },
};